import { render, staticRenderFns } from "./DialogRole.vue?vue&type=template&id=fb9d0f6e&scoped=true"
import script from "./DialogRole.vue?vue&type=script&lang=js"
export * from "./DialogRole.vue?vue&type=script&lang=js"
import style0 from "./DialogRole.vue?vue&type=style&index=0&id=fb9d0f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9d0f6e",
  null
  
)

export default component.exports